<app-form-generator #form [formData]="config?.formConfig?.formData"
    [dynamicValidator]="config?.formConfig?.dynamicValidator || []" />
<div *ngIf="showErr" class="error text-center">Make Sure All Field Are Valid</div>
<div class="text-center my-2">
    <m-button label="Filter" [loading]="filterLoader" icon="pi pi-filter" severity="secondary"
        (onClick)="onFilter($event)" />
    <m-groupButton #btnGroup [btnGroup]="config.buttons || []" (onClick)="onClickBtn($event)" />
</div>
<app-table-list #tableList [tableConfig]="config.tableConfig" [parentGetList]="getListData" [viewAction]="viewActionCall"
    [parenttblAction]="tblActionCall" />